module.exports = __webpack_public_path__ + "img/banner-tc1.1e9fb1dd.jpg";